import CustomDialog from 'Components/CustomDialog'
import CustomLoadingButton from 'Components/CustomLoadingButton'
import NumberFormField from 'Components/NumberFormField'
import StyledForm from 'Components/StyledForm'
import { Button, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import { type FormEvent, useState } from 'react'
import { t } from 'ttag'

interface BulkTicketSaleBatchDialogProps {
  open: boolean
  handleClose: () => void
  handleSubmit: (amount: number) => void
  isLoading: boolean
  title: string
  eventIdentifier: string
}

export default function BulkTicketSaleBatchDialog({
  open,
  handleClose,
  handleSubmit,
  isLoading,
  title,
  eventIdentifier
}: Readonly<BulkTicketSaleBatchDialogProps>) {
  const [ticketAmount, setTicketAmount] = useState<number | undefined>(undefined)
  const onClose = () => {
    setTicketAmount(undefined)
    handleClose()
  }

  const onSubmit = (e: FormEvent) => {
    e.preventDefault()
    if (ticketAmount !== undefined) {
      handleSubmit(ticketAmount)
    }
  }

  return (
    <CustomDialog open={open} handleClose={onClose}>
      <StyledForm onSubmit={onSubmit}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <Typography
            sx={{ mb: 2 }}
          >{t`This will create a batch of tickets for the selected event: ${eventIdentifier}.`}</Typography>
          <NumberFormField
            sx={{ width: '100%' }}
            unit={t`pcs`}
            required
            name="requested_quantity"
            label={t`Enter ticket quantity`}
            value={ticketAmount ?? ''}
            inputProps={{ min: 1, max: 25000 }}
            helperText={t`You can create up to 25,000 tickets at a time`}
            onChange={e => setTicketAmount(e.target.value ? Number(e.target.value) : undefined)}
            defaultOptions={[250, 500, 1000]}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} size="large" sx={{ mt: 2 }}>{t`Cancel`}</Button>
          <CustomLoadingButton autoFocus type="submit" isLoading={isLoading}>
            {t`Create tickets`}
          </CustomLoadingButton>
        </DialogActions>
      </StyledForm>
    </CustomDialog>
  )
}
